import React, { useCallback, useRef } from 'react'

const useFileUpload = (onUploadPhoto: (fileUrl: string) => void) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const openFilePicker = useCallback(() => {
    inputRef.current?.click();
  }, []);

  const handleFileUpload = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.onloadend = () => {
        if (reader.result) {
          onUploadPhoto(reader.result.toString());
        }
      };
      reader.readAsDataURL(file);
    }
  }, [onUploadPhoto]);

  return { inputRef, openFilePicker, handleFileUpload };
}

export default useFileUpload;
